import { render, staticRenderFns } from "./SignupUser.vue?vue&type=template&id=0306f630&scoped=true"
import script from "./SignupUser.vue?vue&type=script&lang=ts"
export * from "./SignupUser.vue?vue&type=script&lang=ts"
import style0 from "./SignupUser.vue?vue&type=style&index=0&id=0306f630&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0306f630",
  null
  
)

export default component.exports